import * as React from 'react';
import { ErrorMessage, useField, useFormikContext } from 'formik';
import { ISpruceField, ISpruceFieldProps, IWrappedField } from './SpruceField';

export interface IWrappedFieldArray<T = any> extends IWrappedField<T> {
  push: (item: any) => void;
  remove: (index: number) => void;
}

export interface ISpruceFieldArrayProps<T = any> extends ISpruceFieldProps<T> {
  field: IWrappedFieldArray<T>;
}

export const SpruceArrayField: React.FC<ISpruceField> = ({ children, ...props }) => {
  const formik = useFormikContext();
  const [field, meta] = useField(props);
  const wrappedField: IWrappedFieldArray = {
    ...field,
    push: (item) => {
      if (Array.isArray(field.value)) {
        (field.value as Array<any>).push(item);
      } else {
        console.error(`Value ${field.name} is not an Array, `, field.value);
      }
    },
    remove: (index) => {
      if (Array.isArray(field.value)) {
        (field.value as Array<any>).splice(index, 1);
      } else {
        console.error(`Value ${field.name} is not an Array, `, field.value);
      }
    },
    onChange: (value: any) => {
      // using any as a first pass.
      formik.setFieldTouched(field.name as never);
      formik.setFieldValue(field.name as never, value);
      if (props.onChange) {
        props.onChange(value);
      }
    },
    errorText: formik.touched[field.name] && meta.error ? <ErrorMessage name={field.name} /> : null,
  };
  return typeof children === 'function' ? children({ field: wrappedField, formik, meta }) : null;
};
